import React from "react"
import Relay from "react-relay"
import { get } from "lodash/object"
import { FormattedMessage } from "react-intl"
import { getFileTypeFromUrl } from "../../scripts/utils"
import { trackDownload } from "../../analyticsAndSocial"
import {
  getImageType,
  getImageSrcFromResource,
  getImageSrcFromFile
} from "../../scripts/resource"
import shareMessages from "../../messages/share"

class ImageDownload extends React.Component {
  render() {
    const { resource, file, isCopyright } = this.props
    const imageType = getImageType(file ? file.type : resource.type)
    return (
      <ul className="list--unstyled list--accentuated">
        {["small", "large", "original"] // needs to align with Relay fragment
          .filter(size => size === "small" || !isCopyright)
          .map(size => [
            size,
            file
              ? getImageSrcFromFile(file, size, imageType, false)
              : getImageSrcFromResource(resource, size, imageType, false)
          ])
          .filter(([, src]) => !!src)
          .map(([size, src]) => {
            const width = file
              ? get(file, ["images", size, "width"], "unknown")
              : get(resource, ["files", 0, "images", size, "width"], "unknown")
            const height = file
              ? get(file, ["images", size, "height"], "unknown")
              : get(resource, ["files", 0, "images", size, "height"], "unknown")

            // TODO: Fix for image downloading. Should be changed in backend
            const fileType = getFileTypeFromUrl(src, ".jpg")
            const downloadSrc =
              size === "original"
                ? src
                : `${src}&response-content-disposition=attachment%3B%20filename%3D${resource.title.replace(
                    /[^\w\s]/gi,
                    "_"
                  )}-${size}${fileType}`

            return (
              <li className="mbt" key={size}>
                <a
                  href={downloadSrc}
                  onClick={e => trackDownload(this.eventLabel(size))}
                  download
                  className="button mbn"
                >
                  <FormattedMessage
                    {...shareMessages.downloadSize}
                    values={{ size: size }}
                  />
                </a>
                {width &&
                  height && (
                    <em className="small subdued inline-block">
                      {width} &times; {height}
                    </em>
                  )}
              </li>
            )
          })}
      </ul>
    )
  }

  eventLabel = size => {
    const {
      resource: { type, title, id }
    } = this.props
    return `${type}-${size}-${id}-${title}`
  }

  // extension = mimeType => mimeType && mimeType.split("/")[1]
}

export default Relay.createContainer(ImageDownload, {
  fragments: {
    resource: () => Relay.QL`
    fragment on Resource {
      id
      title
      type
      files {
          id
          type
          size
          images {
            small { url width height mime_type }
            large { url width height mime_type}
            original { url width height mime_type }
          }
      }
    }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/elements/ImageDownload.js